<h2 mat-dialog-title>Modification des rôles :</h2>

<div mat-dialog-content style="overflow: hidden">
  <p>
    Vous êtes sur le point de modifier les rôles pour l'utilisateur :
    <strong>{{user?.nom | uppercase}} {{user?.prenom}}</strong> <br>
    <small>e-mail : {{user?.email}}</small>
  </p>
  <p>
    <button mat-stroked-button color="warn" (click)="modification = !modification">
      {{(modification) ? 'Désactiver' : 'Activer'}} la modification
    </button>
  </p>

  <mat-radio-group [disabled]="!modification" [(ngModel)]="wantedRole" class="example-radio-group">
    @for (role of roles; track role; let i = $index) {
      <mat-radio-button [value]="role.id"
        [checked]="getCurrentRole() === role.code" class="example-radio-button">
        {{role.label}}
      </mat-radio-button>
    }
  </mat-radio-group>
</div>

<div mat-dialog-actions>
  <button mat-dialog-close mat-button>Annuler</button>
  <button mat-raised-button [color]="'primary'" [disabled]="!modification" (click)="saveRole()">
    Sauvegarder les rôles
  </button>
</div>
